module.exports = __webpack_public_path__ + "static/media/Closing ceremonies.8fbb1cc9.png";